<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .videoList{
    /*width: 1200px;*/
    /*margin: 0 auto;*/
    background: url("../assets/img/bg.png")no-repeat;
    background-position-y:top;
    width: 100%;
    overflow: hidden;
  }
  .videoList .nav{
    background:url('../assets/img/navbg.png')no-repeat;
    width: 1530px;
    height: 120px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .videoList .nav img{
    float: left;
    margin-left: 160px;
    margin-top: 35px;
  }
  .videoList .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .videoList .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 120px;
    text-align: center;
    line-height: 120px;
    color: #ebbfbf;
    font-size: 16px;
    font-weight: 900;
    cursor: pointer;
    position: relative;
  }
  .videoList .nav ul li span{
    position: absolute;
    left: 0;
    bottom: -25px;
    text-align: center;
    width: 100%;
    font-weight: 100;
  }
  .videoList .nav ul li:hover{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 21px;
  }
  .videoList .nav ul li.on{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 21px;
  }
  .videoList .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .videoList .content {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 195px;
  }
  .videoList .content .title{
    margin-top: 100px;
    color: #ffffff;
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 30px;
  }
  .videoList .content .title img{
    margin-right: 15px;
  }
  .videoList .content .vList ul{
    overflow: hidden;
  }
  .videoList .content .vList ul li{
    width: 260px;
    float: left;
    margin-right: -25px;
    margin-bottom: -5px;
    position: relative;
    height: 235px;
  }
  .videoList .content .vList ul li img{
    width: 215px;
    height: 122px;
  }
  .videoList .content .vList ul li p {
    margin-top: 20px;
    color: #ffffff;
    font-size: 16px;
    display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
    -webkit-line-clamp: 2; /*显示的行数；如果要设置2行加...则设置为2*/
    overflow: hidden;
    text-overflow: ellipsis; /* 溢出用省略号*/
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;/*伸缩盒子的子元素排列：从上到下*/
  }
  .videoList .content .vList ul li:hover .mask{
    opacity: 1;
  }
  .videoList .content .vList ul li .mask{
    width: 260px;
    height: 235px;
    background: #c21415;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity .1s ease,transform 0.1s ease,-webkit-transform .1s ease;
  }
  .videoList .content .vList ul li .mask img{
    margin: 0 auto;
    text-align: center;
    width: 250px;
    height: 140px;
    margin-top:4px;
    margin-left: 4px;
  }
  .videoList .content .vList ul li .mask p{
    width: 200px;
    text-align: center;
    /*display: inline-block;*/
    margin: 0 auto;
    margin-top: 25px;
    padding: 0 25px;
  }
</style>
<template>
  <div class="videoList">
    <myhead></myhead>
    <nav class="nav">
      <img src="../assets/img/logo.png" alt=""/>
      <ul>
        <li @click="urlFun('/home')"> 首页 <span>Home</span></li>
        <li @click="urlFun('/news')">新闻<span> News</span></li>
        <li @click="urlFun('/rules')">规则<span> Rule</span></li>
        <li @click="urlFun('/match')">赛程<span>Schedule</span></li>
        <li class="on" @click="urlFun('/videoList')">视频<span>Video</span></li>
        <li @click="urlFun('/live')">直播<span> Live</span></li>
      </ul>
      <div class="btn" @click="urlFun('/signUp')"></div>
    </nav>
    <div class="content">
      <div class="title"><img src="../assets/img/title.png" alt=""/>视频</div>
      <div class="vList">
        <ul>
          <li v-for="(key,index) in newsList" @click="newFun(key.news_id)">
            <div style="position: absolute; width: 215px; height: 122px; left: 50%; margin-left: -107px;">
              <img :src="'http://admin.matchon.net/'+key.newsPic" alt=""/>
              <p>{{key.newsTitle}}</p>
            </div>
            <div class="mask">
              <img :src="'http://admin.matchon.net/'+key.newsPic" alt=""/>
              <img style="position: absolute;z-index: 2;left: 0;    height: 141px;" src="../assets/img/videoMask.png" alt=""/>
              <p>{{key.newsTitle}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <mybottom></mybottom>
  </div>
</template>

<script>
    import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  export default {
    name: 'Rules',
    components: {
      myhead,
      mybottom
    },
    data () {
      return {
        newsList:"",
      }
    },

    computed:{

    },
    mounted(){
      this.newsData()
    },
    methods:{
      newsData(){
        let _this=this;
        let formd=new FormData()
        formd.append("rowNum",8)
        formd.append("seriesId",30)
        formd.append("matchId",139)
        formd.append("type",2)
        this.$axios.post("http://admin.matchon.net/client/getNewsList",formd).then((data) => {
          if(data.data.code==200){
            _this.newsList=data.data.data;
          }
        });
      },
      newFun(id){
        this.$router.push({path: '/video', query: {vid: id}})
      },
      urlFun(url){
        this.$router.push({path:url})
      },

    },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/videoList.vue